import React, { useState } from 'react';
import DashboardLeftMenu from '../../Dashboard/DashboardLeftMenu';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardHeader from '../../Header/DashboardHeader';

function DashboardLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className={`wrapper ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <DashboardLeftMenu onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className="main">
        <DashboardHeader />
        {children}
        <DashboardFooter />
      </div>
    </div>
  );
}

export default DashboardLayout;
